export const openSourceAssets = {
  openSource: {
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/ai-and-ml.webp`,
      emerging2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/blockchain.webp`,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/internet-of-things.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/big-data-analytics.webp`,
      emerging5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/cloud-computing.webp`,
      emerging6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/cybersecurity.webp`,
      emerging7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/emerging/vr.webp`,
    },
    process: {
      process1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/project-understanding.webp`,
      process2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/strategic-planning.webp`,
      process3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/visual-and-ui-design.webp`,
      process4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/draft-and-development.webp`,
      process5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/qa-testing.webp`,
      process6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/Open-source-page/process/launch-maintain.webp`,
    },
  },
};
